import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Footer from "../Components/Footer";
import Form from "./Form.jsx";
import { CartProvider } from "react-use-cart";
function Contact() {
  return (
    <CartProvider>
      <Navbar />
      <Hero value={<h1>Contact</h1>} />
      <Form />
      <Footer />
    </CartProvider>
  );
}

export default Contact;
